import { useQuery } from '@tanstack/react-query';
import type { Campaign, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

/**
 * The list endpoint returns full campaign rows. Auto-campaign fires carry
 * `is_auto=true` (a schema column serialized by the API's snake-case
 * middleware, not yet part of the shared CampaignSchema). Typed here so the
 * UI can separate auto-pilot fires from manual goal campaigns.
 */
export type CampaignListItem = Campaign & { is_auto?: boolean };

export function useCampaigns(projectId?: string, limit = 50) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['campaigns', { projectId, limit }],
    queryFn: () =>
      apiGet<CursorPage<CampaignListItem>>(`/v1/campaigns?${params.toString()}`),
  });
}
